import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { JupiterInspectionNote } from '../../types/jupiter-inspection-note.type';

@Component({
  selector: 'app-lot-moto-jupiter-inspection-card-notes',
  templateUrl: './lot-moto-jupiter-inspection-card-notes.component.html',
  styleUrls: ['./lot-moto-jupiter-inspection-card-notes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotMotoJupiterInspectionCardNotesComponent {
  @Input() set notes(notes: Record<string, string>) {
    this.normalizedNotes = Object.entries(notes)
      .map(
        ([title, text]) =>
          <JupiterInspectionNote>{
            title,
            text,
          },
      )
      .filter((note) => !!note.text);
  }

  normalizedNotes: JupiterInspectionNote[] = [];
}
